import React from "react";
export default () =>
  <nav>
    <ul>
      <li>
        <a href="#quiz">
          Quiz
        </a>
      </li>
      <li>
        <a href="#quizQR">
          QuizQR
        </a>
      </li>
      <li>
        <a href="#slope-factors">
          Slope Chart Factors
        </a>
      </li>
      <li>
        <a href="#slope-wealth">
          Slope Chart Forms of Wealth
        </a>
      </li>
      <li>
        <a href="#internal-survey">
          Internal Survey
        </a>
      </li>
      <li>
        <a
          className="download"
          href="/static/build.zip"
          download="millennials-app.zip"
        >
          Download Code
        </a>
      </li>
    </ul>
    <style jsx>{`
      nav {
        background: #333;
        width: 100vw;
        font-family: sans-serif;
        font-size: 12px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
      }
      ul {
        display: flex;
        margin: 0;
        padding: 10px;
        justify-content: flex-end;
      }
      li {
        display: block;
        margin: 0 10px;
        list-style: none;
      }
      a {
        color: white;
        text-decoration: none;
      }
      a:hover {
        text-decoration: underline;
      }
      a.download {
        color: #f55;
      }
    `}</style>
  </nav>;



// WEBPACK FOOTER //
// ./src/components/PrototypeNavigation.js